import { ROUTE } from "../../../routes";
import { ButtonTypeTokens, DocumentPickerState, } from "@voltmoney/schema";
import { api } from "../../../configs/api";
import SharedPropsService from "../../../SharedPropsService";
import _ from "lodash";
import { getAppHeader } from "../../../configs/config";
import { nextStepCredStepper, uploadToS3Bucket } from "../../../configs/utils";
import { Platform, ToastAndroid } from "react-native";
let documentUploadUrlMap = {
    frontDocURL: null,
    backDocURL: null,
};
const validation = {
    isFrontDocUploaded: false,
    isBackDocUploaded: false,
};
let isError = false;
let isErrorBack = false;
export const GoBackAction = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.KYC_STEPPER);
};
export const triggerAction = async (action, _datastore, { setDatastore, network, navigate }) => {
    const user = await SharedPropsService.getUser();
    const applicationId = user.linkedApplications[0].applicationId;
    await setDatastore(ROUTE.KYC_DOCUMENT_UPLOAD_POA, "continue", {
        loading: true,
    });
    const response = await network.get(`${api.documentValidatePOA}${applicationId}`, { headers: await getAppHeader() });
    await setDatastore(ROUTE.KYC_DOCUMENT_UPLOAD_POA, "continue", {
        loading: false,
    });
    const currentStepId = _.get(response, "data.updatedApplicationObj.currentStepId");
    const stepStatusMap = _.get(response, "data.updatedApplicationObj.stepStatusMap");
    if (currentStepId == undefined ||
        currentStepId == "KYC_DOCUMENT_UPLOAD_POA") {
        return;
    }
    else {
        user.linkedApplications[0].currentStepId = currentStepId;
        user.linkedApplications[0].stepStatusMap = stepStatusMap;
    }
    if (currentStepId) {
        await SharedPropsService.setUser(user);
        const routeObj = await nextStepCredStepper();
        await navigate(routeObj.routeId, routeObj.params);
    }
};
export const documentPickerAction = async (action, _datastore, { network, setDatastore }) => {
    if (action.payload.value) {
        let fileExtension;
        isError = false;
        isErrorBack = false;
        console.log("File received in microfrontend", action.payload.value);
        if (action.payload.value.name === undefined) {
            console.log("Entered here");
            fileExtension = action.payload.value.fileName.split(".").pop();
            console.log("Entered here done", fileExtension);
        }
        else {
            fileExtension = action.payload.value.name.split(".").pop();
        }
        await setDatastore(ROUTE.KYC_DOCUMENT_UPLOAD_POA, action.payload.widgetID, {
            state: DocumentPickerState.LOADING,
        });
        if (Platform.OS !== "web") {
            console.log("Inside this thingy");
            uploadToS3Bucket(action.payload.widgetID === "frontSide"
                ? documentUploadUrlMap.frontDocURL
                : documentUploadUrlMap.backDocURL, action.payload.value, await getContentType(fileExtension))
                .then(async (isUploaded) => {
                console.log("HERERERE");
                console.log("in the success block $$$$$$", action.payload.widgetID, isUploaded);
                action.payload.widgetID === "frontSide" ? isError = false : isErrorBack = false;
                if (!isUploaded) {
                    ToastAndroid.show("Upload failed! Please try again", ToastAndroid.LONG);
                    return;
                }
                if (action.payload.widgetID === "frontSide") {
                    validation.isFrontDocUploaded = true;
                }
                if (action.payload.widgetID === "backSide") {
                    validation.isBackDocUploaded = true;
                }
                if (documentUploadUrlMap.backDocURL === null) {
                    validation.isBackDocUploaded = true;
                }
                await setDatastore(ROUTE.KYC_DOCUMENT_UPLOAD_POI, action.payload.widgetID, {
                    state: DocumentPickerState.SUCCESS,
                });
                await setDatastore(ROUTE.KYC_DOCUMENT_UPLOAD_POI, "continue", {
                    type: ButtonTypeTokens.LargeFilled,
                });
                return;
            })
                .catch(async () => {
                console.log("in the error block", validation.isBackDocUploaded);
                ToastAndroid.show("Upload failed! Please try again", ToastAndroid.LONG);
                validation.isBackDocUploaded = false;
                action.payload.widgetID === "frontSide" ? isError = true : isErrorBack = true;
                // await setDatastore(
                //   ROUTE.KYC_DOCUMENT_UPLOAD_POI,
                //   action.payload.widgetID,
                //   <DocumentPickerProps>{
                //     state: DocumentPickerState.DEFAULT,
                //   }
                // );
                return;
            });
            // uploadImage(action.payload.value,documentUploadUrlMap.frontDocURL, fileExtension, action.payload.value.type)
        }
        const response = await network.put(action.payload.widgetID === "frontSide"
            ? documentUploadUrlMap.frontDocURL
            : documentUploadUrlMap.backDocURL, action.payload.value, {
            headers: { "Content-Type": getContentType(fileExtension) },
        });
        if (response.status === 200) {
            if (action.payload.widgetID === "frontSide") {
                validation.isFrontDocUploaded = true;
            }
            if (action.payload.widgetID === "backSide") {
                validation.isBackDocUploaded = true;
            }
            if (documentUploadUrlMap.backDocURL === null) {
                validation.isBackDocUploaded = true;
            }
            await setDatastore(ROUTE.KYC_DOCUMENT_UPLOAD_POA, action.payload.widgetID, {
                state: DocumentPickerState.SUCCESS,
            });
        }
        else {
            await setDatastore(ROUTE.KYC_DOCUMENT_UPLOAD_POA, action.payload.widgetID, {
                state: DocumentPickerState.DEFAULT,
            });
        }
    }
    console.log("Code reached here");
    if (validation.isFrontDocUploaded && validation.isBackDocUploaded && !isError && !isErrorBack) {
        console.log("Button type changing");
        await setDatastore(ROUTE.KYC_DOCUMENT_UPLOAD_POA, "continue", {
            type: ButtonTypeTokens.LargeFilled,
        });
    }
    else {
        await setDatastore(ROUTE.KYC_DOCUMENT_UPLOAD_POA, "continue", {
            type: ButtonTypeTokens.LargeOutline,
        });
    }
};
export const onPageLoad = async (action, _datastore, { network, removeWidgets, appendWidgets, setDatastore }) => {
    validation.isFrontDocUploaded = false;
    validation.isBackDocUploaded = false;
    await setDatastore(ROUTE.KYC_DOCUMENT_UPLOAD_POA, "continue", {
        type: ButtonTypeTokens.LargeOutline,
    }); // reset continue button
    const applicationId = (await SharedPropsService.getUser())
        .linkedApplications[0].applicationId;
    const documentUrlResponse = await network.post(`${api.kycDocumentPOA}${applicationId}`, { documentType: "AADHAAR" }, { headers: await getAppHeader() });
    documentUploadUrlMap = documentUrlResponse.data.stepResponseObject;
    // await removeWidgets(ROUTE.KYC_DOCUMENT_UPLOAD_POA, [
    //   { id: "frontSide", type: WIDGET.DOCUMENT_PICKER },
    //   { id: "frontSideSpace", type: WIDGET.SPACE },
    //   { id: "backSide", type: WIDGET.DOCUMENT_PICKER },
    // ]);
    //
    // const datastore: Datastore = {
    //   frontSide: <DocumentPickerProps & WidgetProps>{
    //     titleLabel: "Front side",
    //     ctaLabel: "Upload",
    //     state: DocumentPickerState.DEFAULT,
    //     action: {
    //       type: ACTION.SELECT_DOCUMENT,
    //       routeId: ROUTE.KYC_DOCUMENT_UPLOAD_POA,
    //       payload: <DocumentUploadPayload>{
    //         value: { content: null, name: null },
    //         widgetID: "frontSide",
    //       },
    //     },
    //   },
    // };
    //
    // if (documentUploadUrlMap.backDocURL !== null) {
    //   datastore["frontSideSpace"] = <SpaceProps>{ size: SizeTypeTokens.XXXL };
    //   datastore["backSide"] = <DocumentPickerProps & WidgetProps>{
    //     titleLabel: "Back side",
    //     ctaLabel: "Upload",
    //     state: DocumentPickerState.DEFAULT,
    //     action: {
    //       type: ACTION.SELECT_DOCUMENT,
    //       routeId: ROUTE.KYC_DOCUMENT_UPLOAD_POA,
    //       payload: <DocumentUploadPayload>{
    //         value: { content: null, name: null },
    //         widgetID: "backSide",
    //       },
    //     },
    //   };
    // }
    //
    // await appendWidgets(
    //   ROUTE.KYC_DOCUMENT_UPLOAD_POA,
    //   datastore,
    //   [
    //     { id: "frontSide", type: WIDGET.DOCUMENT_PICKER },
    //     { id: "frontSideSpace", type: WIDGET.SPACE },
    //     { id: "backSide", type: WIDGET.DOCUMENT_PICKER },
    //   ],
    //   "dropDownSpace"
    // );
};
const getContentType = (fileExtension) => {
    switch (fileExtension) {
        case "pdf":
            return "application/pdf";
        case "png":
            return "image/png";
        case "jpg":
            return "image/jpeg";
        case "jpeg":
            return "image/jpeg";
        default:
            return "application/pdf";
    }
};
